// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Ck-z","breadcrumbItem":"Dk-z"};